import { useEffect, useRef } from "react";

/**
 * The `useMounted` function returns a reference to a boolean value that indicates whether the
 * component is currently mounted or not.
 * @returns The `useMounted` function returns a `ref` object that holds a boolean value indicating
 * whether the component is currently mounted or not.
 */
export function useMounted() {
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => (isMountedRef.current = false);
  }, []);

  return isMountedRef;
}
